import * as S from './Card.styled';

export default S.Card;
